import React from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
Theme(Highcharts)

const LineChart: any = (props: any) => {
	// console.log(props.allData);
	let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
	function formatMilesChileno(number: any) {
		return number
			.toString()
			.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	}
	const { allData, exportExcel, exportarImagen, labels, title, subtitle, idChart, activeButton, colores, formatDataStringData, numDecimalProps, pieTextProps, showPieTextInGraph, showSeries, isRevertGraphY, mostrarlegend, isThousandFormat } = props;
	const options = {
		chart: {
			type: 'spline',
			colorCount: 15,
			zoomType: 'x',
			backgroundColor: '#ffffff',


		},

		title: {
			text: title,

			style: {
				color: '#19355F',
				fontFamily: 'Montserrat-SemiBold',
				fontSize: '14px',

			}
		}
		, subtitle: {
			text: subtitle,
			style: {
				fontSize: '10px',
				color: '#19355F',
				fontFamily: 'Montserrat-Medium',
				width: '80%',
				wordBreak: 'break-word'
			}

		},

		yAxis: {
			minorGridLineWidth: 0,
			gridLineWidth: 0,
			title: "enabled"
			, reversed: isRevertGraphY,
			labels: {
				formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {

					if (isThousandFormat) {
						return formatMilesChileno(this.value) + (formatDataStringData ? formatDataStringData : '');
					}
					else {
						return this.value + (formatDataStringData ? formatDataStringData : '');
					}


	
				},
			}
		},



		xAxis: {
			gridLineWidth: 0,
			categories: labels,
			max: (labels.length - 1)
		},

		tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
			pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
				'<td style="text-align: right"><b>{point.y}' + formatDataStringData + '</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: numDecimalProps
		},


		plotOptions: {
			series: {
				dataLabels: {
					formatter: function (this: Highcharts.PointLabelObject) {


						//@ts-ignore
						if (numDecimalProps === 0) {
							const vaar: any = this;
							//@ts-ignore
							if (isThousandFormat) {
								return formatMilesChileno(this.y) + (formatDataStringData ? formatDataStringData : '');
							}
							else {
								return vaar.y.toFixed(0) + (formatDataStringData ? formatDataStringData : '')
							}
							; // Mostrar sin decimales si es un número entero
						} else {

							const vaar: any = this;
							if (isThousandFormat) {
								return formatMilesChileno(this.y) + (formatDataStringData ? formatDataStringData : '');
							}
							else {
								return vaar.y.toFixed(numDecimalProps) + (formatDataStringData ? formatDataStringData : ''); // Mostrar con dos decimales en otros casos

							}
							//@ts-ignore
						}

						// 	/@ts-ignore
						// if (numDecimalProps === 0) {
						// 	//@ts-ignore

						//   return this.y.toFixed(0) + (formatDataStringData?formatDataStringData:''); // Mostrar sin decimales si es un número entero
						// } else {
						// 							//@ts-ignore
						//   return this.y.toFixed(numDecimalProps)  + (formatDataStringData?formatDataStringData:''); // Mostrar con dos decimales en otros casos
						// }


					},
					align: 'right',
					enabled: showSeries,
					inside: false
				},
				grouping: true
			}
		},
		credits: {
			enabled: pieTextProps.length > 0 && showPieTextInGraph ? true : false,
			text: pieTextProps,
			style: {
				fontSize: '10px',
				fontFamily: 'Montserrat',
				color: '#19355F',

			},
			useHTML: true,// Permite el uso de HTML en el pie de página
			position: {
				align: 'right',
				x: -10,
				verticalAlign: 'bottom',
				y: -5
			}
		},


		series: allData,
		// colors: ['#00A3E0', '#8031A7', '#B5BD00', '#ed8b00', '#09699c', '#ffc000', '#E0004D',
		// 		 '#00C389', '#707372', '#bfbfbf'],
		colors: colores,
		legend: {
			enabled: mostrarlegend,
			padding: 20,
			symbolPadding: 5,
			itemDistance: 60,
			backgroundColor: '#FFFFFF',
			itemStyle: {
				color: '#19355F',
				fontFamily: 'Montserrat',
				fontSize: '10px',
				fontWeight: 'normal',
				padding: 50
			}
		},

		responsive: {
			rules: [{


				condition: {
					maxWidth: 1000
				},
				chartOptions: {
					title: {
						style: {
							fontFamily: 'Sans-Serif',
							fontSize: '14px',

						}
					},
					xAxis: {
						labels: {
							style: {
								fontSize: '10px',
							}
						}

					},
					yAxis: {
						labels: {
							style: {
								fontSize: '10px',
							}
						}

					},
					legend: {

						enabled: mostrarlegend,
						backgroundColor: '#FFFFFF',
						itemStyle: {
							color: '#19355F',
							fontFamily: 'Montserrat',
							fontSize: '11px',
							fontWeight: 'normal',
							padding: '10',
							symbolRadius: 6,
							symbolWidth: 22,
							symbolPadding: 10,

						}
					},
					subtitle: {
						style: {
							color: '#19355F',
							fontFamily: 'Montserrat',
							width: '80%',
							wordBreak: 'break-word',
							fontSize: '10px',

						}

					},

				}
			}]
		},

		lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
		},

		exporting: {
			enabled: activeButton,
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event: any) => {
						console.log('clic boton custom');
						exportExcel({ titulo: title, id: idChart });
					},
					text: 'Descargar XLSX'
				},
				descargarImagen: {
					onclick: (event: any) => {
						console.log('clic boton custom');
						exportarImagen();
					},
					text: 'Descargar Imagen'
				},
			},

			buttons: {
				contextButton: {
					menuItems: [
						"descargarImagen",
						"separator",
						"label"
					]
				}
			}
		},

	}

	return (
		<>
			<HighchartsReact highcharts={Highcharts} options={options} />
		</>
	)
}

export default LineChart;